import { computed } from "vue";
import { useMediaQuery } from "@vueuse/core";
import { useFinder } from "#ce/composables/useFinder";
import { useHostElement } from "#ce/composables/useHostElement";
import { resolveFinder } from "#ce/shared/finder-association";
import { RESULT_COMMANDS } from "#ce/components/SpFinder/engine/result-commands";
import { MAP_COMMANDS } from "#ce/components/SpFinder/engine/map-commands";

/** Reads completed-generation map inputs and delegates commands to the associated wrapper. */
export function useFinderMap() {
  const host = useHostElement();
  const finder = useFinder();
  const mobile = useMediaQuery("(max-width: 750px)");
  function command(name) {
    return function runMapCommand(...args) {
      if (finder.connected.value) {
        return resolveFinder(host).element?.[name]?.(...args);
      }
    };
  }
  const payload = computed(() => finder.completed.value?.result);
  const records = computed(() => payload.value?.results ?? []);
  return {
    host,
    mobile,
    payload,
    records,
    kind: finder.kind,
    settings: computed(() => finder.settings.value?.map),
    cardSettings: computed(() => finder.settings.value?.results),
    selection: finder.mapSelection,
    mode: finder.mapBoundsMode,
    selected: computed(() =>
      records.value.find((record) => record.resultGUID === finder.mapSelection.value?.resultGUID),
    ),
    desktop: computed(() => !mobile.value && finder.completed.value?.view === "map"),
    loading: computed(() => finder.request.value?.status === "loading"),
    generation: computed(() => finder.completed.value?.generation),
    params: computed(() => payload.value?.map_fetch_params ?? finder.completed.value?.params),
    commands: Object.fromEntries([...RESULT_COMMANDS, ...MAP_COMMANDS].map((name) => [name, command(name)])),
  };
}
